/**
 * Meta (Facebook) Pixel — used ONLY on the signup flow (pages/Signup.js) so
 * Facebook ads can optimise for real signups.
 *
 * Privacy:
 *  - Never loaded from public/index.html or on any page after login.
 *  - No advanced matching: init is called WITHOUT any user data, and callers
 *    must only pass non-personal params (no email / phone / name).
 *  - After signup the dashboard opens in this same browser tab. The pixel by
 *    default sends a PageView on every in-app screen change and collects button
 *    clicks / page data by itself — both are switched off below, so nothing from
 *    the ERP screens reaches Meta.
 *
 * Tracking must never affect signup: every call is wrapped and does nothing
 * when the pixel is blocked (ad-blockers) or not loaded.
 */
export const META_PIXEL_ID = '634199804760162';

let started = false;

export const initMetaPixel = () => {
  if (started || typeof window === 'undefined') return;
  started = true;
  try {
    if (!window.fbq) {
      // Standard Meta base code: a queue stub now, the real script loads async
      // and plays the queue back.
      const n = function () {
        // eslint-disable-next-line prefer-rest-params
        if (n.callMethod) n.callMethod.apply(n, arguments); else n.queue.push(arguments);
      };
      window.fbq = n;
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const s = document.createElement('script');
      s.async = true;
      s.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const first = document.getElementsByTagName('script')[0];
      if (first && first.parentNode) first.parentNode.insertBefore(s, first);
      else document.head.appendChild(s);
    }
    // No automatic PageView on later in-app screen changes (dashboard etc.).
    window.fbq.disablePushState = true;
    // No automatic button-click / page-data collection.
    window.fbq('set', 'autoConfig', false, META_PIXEL_ID);
    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
  } catch (e) { /* tracking must never affect signup */ }
};

export const trackMetaEvent = (name, params = {}, eventId) => {
  try {
    if (typeof window === 'undefined' || typeof window.fbq !== 'function') return;
    if (eventId) window.fbq('track', name, params || {}, { eventID: String(eventId) });
    else window.fbq('track', name, params || {});
  } catch (e) { /* tracking must never affect signup */ }
};
